import i18n from '@/i18n'
import interfaceWording from '@/settings/interfaceWording'

const state = {
  langs: []
}

const getters = {
  langs: state => state.langs,
  selectedLang: () => i18n.locale,
  fallbackLang: () => i18n.fallbackLocale
}

const mutations = {
  SET_LANGS_DATA (state) {
    const langs = []
    interfaceWording.languages.forEach(language => {
      langs.push(language)
    })
    state.langs = langs
    for (let i = 0; i < state.langs.length; i++) {
      const obj = {}
      const iso = state.langs[i].iso
      Object.keys(interfaceWording.messages).forEach(message => {
        const mess = interfaceWording.messages[message]
        if (mess[iso]) {
          obj[message] = mess[iso]
        }
      })
      i18n.setLocaleMessage(iso, obj)
    }
  },
  SET_LANG (state, lang) {
    for (let i = 0; i < state.langs.length; i++) {
      if (lang === state.langs[i].iso) {
        i18n.locale = lang
        return
      }
    }
    i18n.locale = i18n.fallbackLocale
  }
}

const actions = {
  SetLangData ({
    commit
  }) {
    commit('SET_LANGS_DATA')
  },
  SetLang ({
    commit
  }, lang) {
    commit('SET_LANG', lang)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
